import { formatDate, isLegalAge } from './date.service';

export const formatSsn = (
  input: string,
  previousInput: string | undefined = '',
  addedYearCallback: () => void
) => {
  const ssnRegex = /^\d*$/;

  if (!ssnRegex.test(input)) {
    return previousInput;
  }

  if (previousInput.length === 1 && input.length === 2) {
    if (input !== '19' && input !== '20') {
      const fullYear = addYear(input);

      if (typeof addedYearCallback === 'function') {
        addedYearCallback();
      }

      return fullYear;
    }
  }

  return input;
};

const addYear = (input: string) => {
  const currentYear = formatDate(undefined, 'YY');
  const controlYear = parseInt(currentYear, 10) - 10;
  const compareYear = parseInt(input.substring(0, 2), 10);

  if (compareYear < controlYear) {
    return `20${input}`;
  } else {
    return `19${input}`;
  }
};

export const moveCursorAfterYear = (inputElement: HTMLInputElement) => {
  setTimeout(() => {
    inputElement.selectionEnd = 4;
    inputElement.selectionStart = 4;
  }, 10);
};

// 890506-9368 -> 198905069368
export const normalizeSsn = (ssn: string | undefined) => {
  if (!ssn) {
    return '';
  }

  const cleanedValue = ssn.replace('-', '');
  const shouldAddYear = cleanedValue.length === 10;
  const withYear = shouldAddYear ? addYear(cleanedValue) : cleanedValue;

  return withYear;
};

export const ensureLegalAge = (input: string | number) => {
  const ssn = typeof input === 'number' ? input.toString() : input;
  const numberRegex = /^\d{12}$/;

  if (numberRegex.test(ssn)) {
    return isLegalAge(ssn);
  }

  const fullYear = formatDate(undefined, 'YYYYMMDD');
  const currentCentury = parseInt(fullYear.substring(0,2), 10);
  const currentYear = parseInt(fullYear.substring(2, 8), 10);

  const compareYear = parseInt(ssn.substring(0, 6), 10);

  let fullAssumedSsn = '';
  // 1-17 101-117 will not be of legal age
  if (compareYear < currentYear) {
    fullAssumedSsn = currentCentury.toString() + ssn;
  } else {
    fullAssumedSsn = (currentCentury - 1).toString() + ssn;
  } 

  return isLegalAge(fullAssumedSsn.substring(0, 8));
};
